import type { AuthChangeEvent, Session } from '@supabase/supabase-js';

/**
 * An onAuthStateChange handler that runs `clear` whenever the signed-in
 * account changes: on sign-out, and when a different user signs in without
 * signing out first (/auth on a browser that still holds a session emits
 * SIGNED_IN, not SIGNED_OUT). Token refreshes and a repeat sign-in of the same
 * user clear nothing; the first event only records who is signed in.
 */
export function onAccountChange(clear: () => void): (event: AuthChangeEvent, session: Session | null) => void {
  let current: string | null | undefined;
  return (event, session) => {
    const userId = session?.user?.id ?? null;
    const changed = current !== undefined && userId !== current;
    current = userId;
    if (event === 'SIGNED_OUT' || changed) clear();
  };
}
